import React, { useContext, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import FormHeader from 'components/Form/Header';
import PasswordForm from 'components/Form/Password';
import { loginUser } from 'store/profile/actions';
import { LoginContext } from './LoginContext';

const SECTION_NAME = 'PASSWORD_INPUT';

const LoginPasswordPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { email } = useContext(LoginContext);

  const onSubmit = useCallback(
    (password) => {
      const errorModal = { returnFocusTo: SECTION_NAME };
      dispatch(loginUser({ email, password, errorModal }));
    },
    [dispatch, email],
  );

  useEffect(() => {
    if (!email) history.replace(`/login/email`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FormHeader
        title="Login"
        description={`Enter you password for ${email}`}
        highlightedValue={email}
      />
      <PasswordForm
        placeholder="Password"
        invalidMessage="Invalid password"
        buttonLabel="Next"
        sectionName={SECTION_NAME}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default LoginPasswordPage;
